import { IEntriesProps, useContentful } from '@smuchile/pkg-unimarc-hooks'
import { ID_HEADER_MENU_BUTTONS } from '../constanst'

interface IConnectionCfHeaderMenu {
  dataHeaderCF?: IEntriesProps
}

const ConnectionCfHeaderMenu = ({
  include
}: { include?: number } = {}): IConnectionCfHeaderMenu => {
  const { data: dataHeaderCF } = useContentful({
    id_contentful: `CentroDeAyuda-HeaderMenu-${include}`,
    options: {
      'sys.contentType.sys.id[in]': 'viewBlock',
      'sys.id[in]': ID_HEADER_MENU_BUTTONS[0],
      include
    },
    reactQuery: {
      enabled: true,
      retry: 3,
      staleTime: 1000 * 60 * 5,
      refetchOnWindowFocus: false
    }
  })

  return {
    dataHeaderCF
  }
}

export { ConnectionCfHeaderMenu }
